module.exports = __webpack_public_path__ + "static/media/SummaryCh12_A01378565.3f5325b3.pdf";